import { render, staticRenderFns } from "./Ordernotes.vue?vue&type=template&id=f34787a6"
import script from "./Ordernotes.vue?vue&type=script&lang=js"
export * from "./Ordernotes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports